import { render } from "./SelectWeaponModal.vue?vue&type=template&id=0a53e6ba&scoped=true"
import script from "./SelectWeaponModal.vue?vue&type=script&lang=js"
export * from "./SelectWeaponModal.vue?vue&type=script&lang=js"

import "./SelectWeaponModal.vue?vue&type=style&index=0&id=0a53e6ba&scoped=true&lang=css"

import exportComponent from "/Users/abdulmanan/Sites/weapsmithing/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a53e6ba"]])

export default __exports__